import React from 'react';
import { Box, Typography } from '@material-ui/core';

import useGetRequest from 'src/hooks/useGetRequest';
import PreviewEmail from './PreviewEmail';
import EmailLoader from './EmailLoader';
import ErrorBoundary from '../../../components/ErrorBoundary';

const PreviewRawEmail = ({
  engagementId,
  recipients,
  ccs,
  bccs,
  subject,
  body,
  isTracked,
  onEditMessage
}: any) => {
  const { result: email, isLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/preview-raw-email/`,
    payload: {
      recipients,
      subject,
      body,
      ccs,
      bccs,
    },
    methodOverride: 'post'
  });

  if (isLoading) return <EmailLoader />;

  return (
    <ErrorBoundary>
      <Box>
        <PreviewEmail
          recipients={email.recipients}
          ccs={email.ccs}
          bccs={email.bccs}
          subject={email.subject}
          body={email.body}
          onEditMessage={onEditMessage}
          isTracked={isTracked}
        />
        {/* <Box pb={1} /> */}
        {/* <Typography variant="subtitle2"> */}
        {/*  * fields will be updated with the latest values at the time the email is sent */}
        {/* </Typography> */}
      </Box>
    </ErrorBoundary>
  );
};

export default PreviewRawEmail;
